import { get } from 'lodash'

const isSubContractor = () => {

  const type = get(window, 'state.user.type')

  return type === 'Admin' || type === 'Subcontractor'

}

export default isSubContractor
